<template>
  <div>
    <div
      class="packht"
    >
      <div class="packtxt">
        <h5>个股研究</h5>
        <div class="imgcontainer" style="margin-top: 20px">
          <div
            style="padding: 17px 10px 10px 10px; margin-top: 20px"
            class="imgtop"
          >
            <TextTop></TextTop>
            <!-- <div>无论机构，还是散户，都需要对股票做财务分析。</div>
            <div>股票投资，还需要财务分析软件！！！</div> -->
          </div>
          <!-- <img
            src="../../assets/img/pic1.png"
            alt=""
            style="margin-left: -10px"
          /> -->
          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(index)"
                  :class="selectIndex == index ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              <div v-if="showlist[0]">
                <p class="title" id="id7">工具一：小文估值</p>
                <p>外来的DCF、DDM等估值算法不适合中国股市，市场上缺乏实用性的价格研究工具。</p>
                <p>借助AI大模型技术，原创的多因子估值算法，用上市公司的利润、资产、市场流动性、市场情绪等多元数据来构建估值体系，绘制在k线图上表现为股票的价值线、支撑线、阻力线。
                </p>
                <p>
                  软件的菜单-》应用场景，有更详细的应用案例资料。
                </p>
                <!-- <p>
                 定价倍数：价格/基本面定价，可作为价值投资的重要参考。如果分析结果的定价倍数小于1，说明这只股票是被市场低估，适合做长期价值投资；相反，如果你短线炒股，需要选定价倍数大于1的。
                </p> -->
                <Imggs
                  :src="require('../../assets/img/jtfx1.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/jtfx1.jpg'))"
                />
                <p style=" font-family: '仿宋', '仿宋GB2312', 'FangSong';">
                  名词解释：左侧交易指在上涨趋势之前买入股票，或者下跌趋势之前卖出股票，是一种区别于以技术分析指标为代表的跟随价格趋势下单的交易方式，跟随趋势下单也称右侧交易。
                </p>
              </div>
              <div v-if="showlist[1]">
                <p class="title" id="id7">工具二：小文财报</p>
                <p>财务报表是企业经营的数字化呈现，而投资决策最重要的是洞察数字背后的潜在变化趋势。上百页的财报信息繁杂、术语专业，让投资者难以快速挖掘出有效的信号。大多的传统财报解读多停留在静态数据展示，难以捕捉企业经营的微妙转折。</p>
                <p>借助AI大模型技术，小文财报以财务数据的季度边际变化为核心，将分析重心从 “数据是多少” 转向 “趋势变多少”，引入 TTM 环增等核心分析口径，聚焦影响股价的关键财务变量，精准识别盈利能力改善、现金流波动、资产结构调整等经营情况变化的拐点信号。
                </p>
                <p>
                 依托文华自研的标准化专业财务分析框架，小文财报在输出上确保逻辑严谨、数据精准、结论稳定一致。从整体经营定调，到三大报表逐层深度解析，紧扣三表勾稽关系，全程层层递进、脉络清晰，不做简单的数据罗列与文本翻译，只为输出有深度、可用于投资决策的核心结论，助力投资者一键捕捉真正有价值的财务信号。
                </p>
                <!-- <p>
                 定价倍数：价格/基本面定价，可作为价值投资的重要参考。如果分析结果的定价倍数小于1，说明这只股票是被市场低估，适合做长期价值投资；相反，如果你短线炒股，需要选定价倍数大于1的。
                </p> -->
                <Imggs
                  :src="require('../../assets/img/aicb.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/aicb.jpg'))"
                />
              </div>
              <div v-if="showlist[2]">
                <p class="title" id="id6">工具三：财务画像</p>
                <p>
                  财报分析能够挖掘企业内部的真实价值，但是，你季报、年报份份不落，看完可能仍然一头雾水？财务画像帮你换个角度，重新建立财报逻辑关系！超越财务报表的芜杂度和局限性，基于企业经营活动逻辑，明确经营资产、金融资产等与盈利、现金流的逻辑关系，迅速刻画企业真实财务画像。
                </p>
                <p>
                  <common-data name="appShortName_26" v-common-display/>基于管理用财务报表和科目的分类重组，对企业的资产、负债、收益和现金流进行了结构化处理，直观展示企业经营性资产负债与金融性资产负债的比重关系、衡量企业利润来源构成、重新搭建三表勾稽关系。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx32.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx32.jpg'))
                  "
                />
                <Imggs
                  :src="require('../../assets/img/jtfx31.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx31.jpg'))
                  "
                />
              </div>
              <div v-if="showlist[3]">
                <p class="title" id="id3">工具四：利润滤镜</p>
                <p>财报“脱水”不必上门调研，利润滤镜帮你对企业利润去伪存真！</p>
                <p>
                  <common-data name="appShortName_26" v-common-display/>的利润滤镜工具，帮你从营运资本投资、资本性支出、非经营性损益、股东权益成本以及递延所得税等五个方面对净利润分别进行调整，挖掘企业真实利润，降低投资风险。
                </p>
                <p>
                  利润滤镜功能分别计算了无滤镜的EPS0（净利润/股本）数值和5个EPS调整值，五大滤镜，为筛选和甄别优质企业提供了辅助决策支持。
                </p>
                <p>
                  EPS1:剔除营运资本。过滤企业当期投入的营运资本，对其预期回报产生的不确定性。
                </p>
                <p>
                  EPS2:剔除资本支出。过滤企业当期资本支出在未来按期进行摊销，对其预期回报产生的不确定性。
                </p>
                <p>
                  EPS3:剔除非经营性损益。辨别企业是否存在主营业务收益不理想，使用非经营性业务获取较高收益的做法。
                </p>
                <p>
                  EPS4:剔除资本成本，将股东预期回报计入成本，辨别企业能否给股东带来超额收益。
                </p>
                <p>
                  EPS5:剔除递延所得税，辨别企业是否存在利用递延所得税进行利润调节的行为。
                </p>
                <p>
                  软件的菜单-》应用场景，有更详细的应用案例资料。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx41.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx41.jpg'))
                  "
                />
                <p>
                  利润滤镜提供的EPS数据叠加图表，可通过分析各曲线的趋势、间距、背离等情况，直观展现企业各年份披露的净利润是否存在水分。
                </p>
                <img src="../../assets/img/jtfx42.png" alt="" />
              </div>
              <div v-if="showlist[4]">
                <p class="title" id="id2">工具五：风险甄别</p>

                <p>
                  年报业绩大增，高于行业整体利润率，这样选股就万无一失了吗？<common-data name="appShortName_26" v-common-display/>的风险甄别功能为你揭示企业财务风险，经营稳健程度和净利润的含金量！
                </p>
                <p>
                  风险甄别利用净现比分析方法从净利润出发，以财报中现金流量表补充资料为核心，分析导致净利润与经营活动现金流差异因素，将资产负债表、利润表和现金流量表关联起来，对企业的运营情况、负债情况及盈利情况进行深度分析并提供相应的风险提示。
                </p>
                <p>
                  软件的菜单-》应用场景，有更详细的应用案例资料。
                </p>
                <img src="../../assets/img/jtfx51.png" alt="" />
                <p>
                  净现比影响因素，可对企业的运营情况、负债情况及盈利情况进行深度分析并提供相应的风险提示。
                </p>
                <p>
                  （1）折旧摊销。从固定资产占比、固定资产和综合折旧率趋势对比、经营活动现金流对资产使用成本的覆盖度、固定资产边际收益等数据，考量企业固定资产投入风险。
                </p>
                <img src="../../assets/img/jtfx52.png" alt="" />
                <p>
                  （2）非经常性损益。从盈余管理风险、投资收益的现金收回比例、处置长期资产收回现金占比等方面甄别企业经营风险。
                </p>
                <img src="../../assets/img/jtfx53.jpg" alt="" />
                <p>
                  （3）减值准备损失等。帮助用户排除企业盈余管理风险和商誉度过高的风险。
                </p>
                <img src="../../assets/img/jtfx54.jpg" alt="" />
                <p>
                  （4）财务费用，提供有息负债占比、财务成本负担率、短期偿债能力、有息负债变动情况等数据，判断是否存在存贷双高等风险。
                </p>
                <img src="../../assets/img/jtfx55.png" alt="" />
                <p>
                  （5）存货。提供存货占比及其对利润的潜在影响、存货占经营成本比例、存货周转与销售模式匹配度等数据，辨别企业在存货管理能力上的风险。
                </p>
                <img src="../../assets/img/jtfx56.jpg" alt="" />
                <p>
                  （6）应收及应付。提供了短期应收账款占比、盈余管理风险、应收票据及应收账款管理等数据，关注企业回收账款和支付能力上的风险。
                </p>
                <img src="../../assets/img/jtfx57.jpg" alt="" />
              </div>
              <div v-if="showlist[5]">
                <p class="title" id="id4">工具六：EVA分析</p>
                <p>
                  资产收益率、毛利率、资本回报率……衡量一家企业经营状况的评价标准如此之多，到底哪个才重要？有了EVA分析，财务评价标准不再混乱！
                </p>
                <p>
                  <common-data name="appShortName_26" v-common-display/>提供的EVA（经济增加值）分析工具，与传统会计利润指标相比，将上市公司各种经营活动归结为一个目的，即如何增加EVA，从而更准确地体现企业的经营状况、价值创造以及真正能给予股东的回报。
                </p>
                <p>
                  EVA经济增加值为正，表明经营者为企业创造了价值；经济增加值为负，表明经营者在损毁企业的价值，即便经营存在利润，但企业的价值在减少。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx61.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/jtfx61.jpg'))"
                />
                <p>
                  EVA修正杜邦分析将净资产EVA率分解为资本EVA率和调整后权益乘数，资本EVA率是单位资本投入创造的EVA值，比率越大表示经营获利能力越强；调整后权益乘数表示财务杠杆大小，比率越小表示财务风险越小。通过与上年同期数据进行对比，可获知企业经营能力的发展变化。
                </p>
                <Imggs
                  :src="require('../../assets/img/jtfx62.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jtfx62.jpg'))
                  "
                />
              </div>
              <div v-if="showlist[6]">
                <p class="title" id="id1">工具七：股息率统计</p>
                <p>
                  大盘涨不上去，炒什么股都亏钱。基金不保本，有风险，收益还不高。看着手里的资金不断贬值，难道真的没有一种收益稳定，还保本的投资方式吗？
                </p>
                <p>
                  这时，不妨尝试购买股息率高、连续分红，且资产增值率稳定的股票，通过获得现金分红，实现稳定收益。
                </p>
                <p>
                  传统股息率算法以自然年为周期，以当前股价作为基准计算，不能客观表征投资者的真实股息收益水平。
                </p>
                <p>
                  原创的财年股息率算法，以上市公司年度分红除权日为起点划分“财年”，计算股息率和资产增值率，开创股息率投资方法，具有更强的现实意义和借鉴价值。
                </p>
                <p>
                  软件的菜单-》应用场景，有更详细的应用案例资料。
                </p>
                <Imggs
                  :src="require('../../assets/img/gxl.jpg')"
                  alt=""
                  @click.native="showimg(require('../../assets/img/gxl.jpg'))"
                />
                <p>
                  股息率_财年=每股现金分红/财年起始5交易日收盘价均值 * 100%。
                </p>
                <p>
                  资产增值率=（财年截止5交易日收盘价均值/财年起始5交易日收盘价均值-1）
                  * 100%。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src="src" :show="ifimg" @change="ifimg = false" />
  </div>
</template>

<script>
import Baseimg from "../view/frame/Baseimg.vue";
import Imggs from "../view/frame/Imggs.vue";
export default {
  components: { Baseimg, Imggs },
  data() {
    return {
      leftList: [
        { name: "小文估值" },
        { name: "小文财报" },
        { name: "财务画像" },
        { name: "利润滤镜" },
        { name: "风险甄别" },
        { name: "EVA分析" },
        { name: "股息率统计" },

      ],
      showlist: [
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      selectIndex: 0,
      src: "",
      ifimg: false,
    };
  },
  methods: {
    select(index) {
      // console.log(1);
      if((!index&&index!==0)||!this.leftList[index]){
        this.select(0)
        return
      }
      this.selectIndex = index;
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      // this.custormAnchor(`id${index + 1}`);
    },
    showimg(e) {
      console.log(e);
      this.src = e;
      this.ifimg = true;
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=11) no-repeat top;
  overflow: hidden;
}
.packtxt {
  width: 990px;
  margin: 0 auto;
  margin-top: 236px;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding: 30px 30px 0 30px;
}
.packtxt h5 {
  font-size: 22px;
  color: #5f5f5f;
  border-bottom: 1px dashed #7f7f7f;

  line-height: 40px;
  margin: 0 auto;
}
.img_box {
  height: 200px;
  margin-top: 20px;
  /* background: #ccc; */
  position: relative;
}
.container {
  width: 100%;
  position: relative;
  /* height: 660px; */
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 195px;
  height: 100%;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  /* margin-top: 1px; */
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  border-bottom: 1px solid #ececec;
  text-indent: 1em;
  position: relative;
  top: -1px;
}
.left_part ul li.active  a{
  border-bottom: none;
}
.right_part {
  display: inline-block;
  width: 695px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  /* overflow-y: auto; */
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}
.img-link {
  position: absolute;
  display: block;
  height: 20px;
  width: 70px;
}
.img-link div {
  width: 100%;
  height: 100%;
}
.imgcontainer {
  padding: 0 10px;
  background: #f5f5f5;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
</style>